import { render, staticRenderFns } from "./PartnerPanelCard.vue?vue&type=template&id=0ae2e378&scoped=true&"
import script from "./PartnerPanelCard.vue?vue&type=script&lang=js&"
export * from "./PartnerPanelCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnerPanelCard.vue?vue&type=style&index=0&id=0ae2e378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2e378",
  null
  
)

export default component.exports